import { FC } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Emptyable } from "@simplyk/common";

import { DashboardIcon } from "@/dashboard-design-system/Icon/DashboardIcon";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";
import { User } from "@/icons/outlined";

export interface EmailPreviewSenderProps {
  name: Emptyable<string>;
  email: Emptyable<string>;
}

export const EmailPreviewSender: FC<EmailPreviewSenderProps> = ({ name, email }) => (
  <Stack direction="row" alignItems="center" gap={1.5}>
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: 28,
        width: 28,
        borderRadius: "50%",
        flexShrink: 0,
        backgroundColor: theme.palette.surface.neutral.quiet,
      })}
    >
      <DashboardIcon size="small" vibe="text-neutral-supershy">
        <User />
      </DashboardIcon>
    </Box>
    <Stack minWidth={0}>
      <DashboardTypography variant="subtitle2" vibe="text-neutral-moderate" data-sensitive="organization-name">
        {name}
      </DashboardTypography>
      <DashboardTypography variant="caption" vibe="text-neutral-moderate" data-sensitive="email">
        {email}
      </DashboardTypography>
    </Stack>
  </Stack>
);
